import { render, staticRenderFns } from "./PsychometryReport.vue?vue&type=template&id=1cc81183&scoped=true"
import script from "./PsychometryReport.vue?vue&type=script&lang=js"
export * from "./PsychometryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc81183",
  null
  
)

export default component.exports